export interface NavBarData {
  routeLink: string;
  icon: string;
  label: string;
}

export const navbarData: NavBarData[] = [
  {
    routeLink: 'conversation-insights',
    icon: 'assets/icons/bar_chart_icon.svg',
    label: 'Insights Dashboard',
  },
  {
    routeLink: 'taxonomy-dashboard',
    icon: 'assets/icons/table_rows.svg',
    label: 'Taxonomy Builder',
  },
  {
    routeLink: 'user-dashboard',
    icon: 'assets/icons/custom_dashboard.svg',
    label: 'User Dashboard',
  },
  {
    routeLink: 'trends',
    icon: 'assets/icons/trends_icon.svg',
    label: 'Trends',
  },
  {
    routeLink: 'freeform-collection',
    icon: 'assets/icons/list_alt.svg',
    label: 'Freeform Collection',
  }
];
